import { lazy } from 'react';

const BrandList = lazy(() => import('./brand-list'));;
const BrandDetail = lazy(() => import('./brand-detail'));;

export default {
  BrandList,
  BrandDetail,
};
